<mat-spinner style="margin: auto" [hidden]="isHidden"></mat-spinner>
